import React from 'react';
import { Card } from '@/components/ui/card';
import { FaTiktok } from "react-icons/fa";
import { Clock, Lock, FileArchive, Award, Shield, Monitor } from "lucide-react";
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
const WhatWeDo = () => {
  return <div className="py-20 bg-gradient-to-b from-[#1A1E29] to-[#0F111A]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-white mb-6">
              Save <span className="text-[#00E5FF]">TikTok Collections</span> Instantly
            </h2>
            <p className="text-gray-400 mb-8">Tokcollect helps you save and access your favorite TikTok content offline. Our advanced technology ensures fast processing while maintaining video quality.</p>
            
            <div className="space-y-4">
              <div className="flex items-center gap-4 bg-[#1E2232]/60 p-4 rounded-xl">
                <div className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center">
                  <Clock className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">Fast Processing</h3>
                  <p className="text-sm text-gray-400">Process entire collections in minutes, not hours</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4 bg-[#1E2232]/60 p-4 rounded-xl">
                <div className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center">
                  <Lock className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">Secure Storage</h3>
                  <p className="text-sm text-gray-400">Your content is stored securely and privately</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4 bg-[#1E2232]/60 p-4 rounded-xl">
                <div className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center">
                  <FileArchive className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">ZIP Export</h3>
                  <p className="text-sm text-gray-400">Download all videos in a convenient ZIP format</p>
                </div>
              </div>

              <div className="flex items-center gap-4 bg-[#1E2232]/60 p-4 rounded-xl">
                <div className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center">
                  <Shield className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">Privacy Protection</h3>
                  <p className="text-sm text-gray-400">Your collections are never shared or indexed</p>
                </div>
              </div>

              
            </div>
          </div>
          
          <div className="lg:order-first">
            <Card className="relative overflow-hidden bg-gradient-to-br from-[#1A2942] to-[#1E1E2E] border-none rounded-3xl p-6 shadow-xl">
              <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-3">
                  <FaTiktok className="w-8 h-8 text-white" />
                  <h3 className="text-2xl font-semibold text-white">My Cooking Collection</h3>
                </div>
                <div className="px-3 py-1 bg-white/10 rounded-full">
                  <span className="text-sm text-white">24 total videos</span>
                </div>
              </div>
              
              <div className="bg-[#111520] rounded-xl p-4 mb-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="text-sm text-gray-400">Processing Status</div>
                  <div className="px-3 py-1 bg-[#00E5FF]/20 text-[#00E5FF] text-xs rounded-full">78% Complete</div>
                </div>
                <div className="w-full h-2 bg-gray-800 rounded-full overflow-hidden">
                  <div className="h-full bg-[#00E5FF] rounded-full" style={{
                  width: '78%'
                }}></div>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="bg-[#111520] rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-white">24</div>
                  <div className="text-sm text-gray-400">Videos Found</div>
                </div>
                <div className="bg-[#111520] rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-[#00E5FF]">19</div>
                  <div className="text-sm text-gray-400">Videos Processed</div>
                </div>
              </div>
              
              <div className="mb-4 bg-[#111520] rounded-xl p-4">
                <div className="text-sm text-gray-400 mb-2">Collection Details</div>
                <div className="flex items-center justify-between">
                  <div className="text-white">Last Updated</div>
                  <div className="text-[#00E5FF]">April 23, 2025</div>
                </div>
                <div className="flex items-center justify-between mt-1">
                  <div className="text-white">Estimated Size</div>
                  <div className="text-[#00E5FF]">142 MB</div>
                </div>
                <div className="flex items-center justify-between mt-1">
                  <div className="text-white">Time Remaining</div>
                  <div className="text-[#00E5FF]">~2 minutes</div>
                </div>
              </div>

              <div className="bg-[#111520] rounded-xl p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-sm text-white font-medium">Format Options</div>
                  <div className="text-[#00E5FF] text-xs">All Selected</div>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <Checkbox id="mp4" className="data-[state=checked]:bg-[#00E5FF] data-[state=checked]:border-[#00E5FF]" defaultChecked />
                    <label htmlFor="mp4" className="text-sm text-gray-300">MP4 Video (High Quality)</label>
                  </div>
                  <div className="flex items-center gap-3">
                    <Checkbox id="mp3" className="data-[state=checked]:bg-[#00E5FF] data-[state=checked]:border-[#00E5FF]" defaultChecked />
                    <label htmlFor="mp3" className="text-sm text-gray-300">MP3 Audio Only</label>
                  </div>
                  <div className="flex items-center gap-3">
                    <Checkbox id="zip" className="data-[state=checked]:bg-[#00E5FF] data-[state=checked]:border-[#00E5FF]" defaultChecked />
                    <label htmlFor="zip" className="text-sm text-gray-300">ZIP Archive (All Files)</label>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>;
};
export default WhatWeDo;